export const GRID_COLUMNS = 12;
export const MOBILE_GRID_COLUMNS = 4;

export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 2.0;
export const ZOOM_STEP = 0.1;
export const PRESET_ZOOMS = [10, 25, 50, 75, 100, 200];
